import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { animate, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'app-right-popup',
  templateUrl: './right-popup.component.html',
  styleUrls: ['./right-popup.component.scss'],
  animations: [
    trigger('popup', [
      transition(':enter', [style({ right: '-100%' }), animate('500ms', style({ right: 0 }))]),
      transition(':leave', [style({ right: 0 }), animate('500ms', style({ right: '-100%' }))]),
    ]),
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RightPopupComponent {
  @Input() name!: string;
  @Input() isOpened: boolean = false;
  @Output() onClose: EventEmitter<void> = new EventEmitter<void>();
}
